import { create} from "zustand"
import { Box3 } from "three"
import { OBB } from 'three/addons/math/OBB.js';
 
interface ModelProperties
{
    boundingBox: Box3 | undefined;
    alignedBoundingBox: OBB | undefined;
    rotationOffset: number;

    setBoundingBox: (value: Box3) => void;
    setAlignedBoundingBox: (value: OBB) => void;
    setRotationOffset: (value: number) => void;

}

export const useModelPropertiesStore = create<ModelProperties>()(
    (set) => ({
        boundingBox: undefined,
        alignedBoundingBox: undefined,
        rotationOffset: 0.0,

        setBoundingBox: (value) => (set({boundingBox: value})),
        setAlignedBoundingBox: (value) => set({alignedBoundingBox: value}),
        setRotationOffset: (value) => set({rotationOffset: value})

    })
);
